import {watch} from '@vue/composition-api'

import useWindowResize from '@/composition/useWindowResize'
import {getViewportWidth, getViewportHeight} from '@/utils/positioning'

export default function useZoom (ref, scale = 1, scaleVertical = false) {
  useWindowResize(setZoom)
  watch(() => ref.value, () => {
    setZoom()
  })

  function setZoom () {
    if (ref.value) {
      const zoomX = getViewportWidth() / 1024 * scale
      const zoomY = scaleVertical ? getViewportHeight() / 1366 * scale : 1.0
      ref.value.style.zoom = Math.min(zoomX, zoomY, 1)
    }
  }
}
